<template>
  <div v-if="readable && itemdata.length < 2" :class="`input ${editable ? '' : 'disabled'} ${viewdata}`"  @mouseleave="hoverOff" @dragstart="hoverOff">
    <label>{{fielddata.label}}</label>
    <div>
			<span class="count">{{images ? images.length : ''}}</span>

			<draggable v-model="images" v-if="itemdata[0]" @change="update">
			    <transition-group>
			        <div class="image" v-for="image in images" :key="image.id">
			            <img :src="`${img}${image.name}`" @mouseover="hover" @mouseleave="hoverOff" />
							<span  v-if="editable" class="actions">
								<a :href="`${img}${image.name}`" target="_blank" class="enlarge btn btn-circle btn-xs btn-warning flex items-center p-2 mr-1"><i class="fa fa-search-plus"></i></a>
								<a v-if="removable" href="javascript:;" v-on:click.prevent="remove(image.id)" class="btn btn-circle btn-xs btn-warning flex items-center p-2"><i class="fa fa-times"></i></a>
							</span>
			        </div>
			    </transition-group>
			</draggable>

      <span v-if="editable" class="upload-manager">
        <div class="upload">
          <table class="table table-hover table-stripe table " v-if="files.length">
            <tr v-for="(file, index) in files" :key="file.id">
              <td>{{file.name}}</td>
            </tr>
          </table>

          <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
            <h3>DROP</h3>
          </div>

          <span class="hide-inline">
            <file-upload
              class="btn btn-1 pull-right"
              :post-action="posturl"
              :headers="{'Authorization': 'Bearer ' + $cookies.get('user_session')}"
              :data="{'item': itemdata[0] ? itemdata[0].id : null}"
              :multiple="true"
              :drop="true"
              :drop-directory="true"
              v-model="files"
              @input-file="inputFile"
              ref="upload">
              <i class="fa fa-plus"></i>
            </file-upload>
          </span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Data from '../../main';
import draggable from 'vuedraggable';
import { global_emits } from '../../main';

export default {
	name: 'ImageInput',
	props: {
		item: Array,
		field: Object,
		view: String,
	},
	computed: {
		// lodash in template
		_() {
			return _;
		},
	},
	watch: {
		item: function() {
			this.itemdata = this.item;
			this.images = _.get(this.itemdata[0], this.fielddata.name);
		},
	},
	data() {
		return {
			fielddata: this.field,
			itemdata: this.item,
			viewdata: this.view,
			img: Data.img_url,
			images: [],
			files: [],
			uploaded: [],
			posturl: process.env.VUE_APP_API_URL + '/image',
			editable: Data.fieldWriteable(this.field.id, Data),
			readable: Data.fieldReadable(this.field.id, Data),
			removable: Data.featureEnabled('remove_image',Data)
		};
	},

	mounted() {
		this.images = _.get(this.itemdata[0], this.fielddata.name);
	},

	methods: {

		hover: (e) => {

			let pos = e.target.getBoundingClientRect();
			let bodyRect = document.body.getBoundingClientRect();
			let hoverImg = e.target.cloneNode();
			hoverImg.classList.add("hover-image");
			hoverImg.id = "hover-image";
			hoverImg.style = `left:${pos.left}px; top:${pos.top - bodyRect.top + 50}px`;

			document.body.appendChild(hoverImg);

		},

		hoverOff: () => {
			let el = document.getElementById('hover-image');
			if (el) {
				el.remove();
			}
		},

		inputFile: function(newFile, oldFile) {
			this.$refs.upload.active = true;
			this.$Progress.start();

			if (newFile && oldFile && !newFile.active && oldFile.active) {
				// Get response data
				//    console.log('response', newFile.response)
				if (newFile.xhr) {
					//  Get the response status code
					// console.log('status', newFile.xhr.status)
				}
			}
			if (newFile && newFile.error) {
				this.$notify({
					group: 'main',
					title: 'Something went wrong.',
					text: 'Please try again.',
					type: 'warn',
				});
			}

			if (newFile && newFile.success) {
				this.uploaded.push(newFile.response.image.id);

				// emit if new item
				if (this.viewdata == 'full'  ) {
					this.$emit('saveTrigger', {
						name: this.field.name,
						value: this.uploaded,
						model: this.field.model
					});
				}

				// creating new item for image view storage
				if (!this.itemdata[0]) {
					this.itemdata = [{image: []}];
				}
				this.item[0][this.field.name] = [newFile.response.image, ...this.item[0][this.field.name]]
				this.images = _.get(this.itemdata[0], this.fielddata.name);

				this.files = _.remove(this.files, function(e) {
					return e.id !== newFile.id;
				});
			}
			this.$Progress.finish();
		},

		remove: function( id ) {

			if (!confirm('Are you sure you want to delete this image?')) return;

			// risk it.
			this.itemdata[0].image = _.remove(this.itemdata[0].image, function(e) {
				return e.id !== id;
			});
			this.images = _.get(this.itemdata[0], this.fielddata.name);
			global_emits.$emit('item_updated', {data:this.itemdata[0], ids: this.$route.params.ids });

			this.$Progress.start();
			this.$axios
				.delete(`/image/${id}`)
				.then((response) => {
					// stay quiet
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},

		update: function(e) {
			let that = this;


			this.itemdata[0].image = that.images;
			global_emits.$emit('item_updated', {data:this.itemdata[0], ids: this.$route.params.ids });

			this.$Progress.start();
			this.$axios
				.put(`/image`, {images: that.images})
				.then((response) => {
					// stay quiet
				})
				.catch((error) => {
					this.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
				});

		}
	},
	components: {
		draggable,
	},
};
</script>

<style scoped>
  .input{
    min-width: 200px;
  }
	.count{
		position: absolute;
    z-index: 1;
    background: #fff;
    padding: 2px 4px;
    right: 1px;
		font-size:8px;
	}

  .input.inline{
		max-width: 150px;
    height: 100%;
    overflow: scroll;
    position: relative;
  }

  .input img{
    border:1px solid #ccc;
    margin: 4px 0 4px 4px;
    vertical-align: top;
  }

  .input.inline img{
    max-height: 40px;
  }

  .input.full img{
    width: 120px;
  }
  .input.full > div{
    min-height: 38px;
  }

  .input, div{
    outline:none;
  }

  .full > div{
    border: 1px solid #efefef;
    margin-bottom: 20px;
  }
  .inline label{
    display: none;
  }

  .batched[contentEditable=true]:not(:focus):before{
    display: inline-block;
    content:'[Batched Editing]';
    color:grey;
  }

  .input .image{
    position: relative;
		display:inline-block;
		cursor:move;
  }


  .image .actions{
    display: none;
    z-index: 11;
    position: absolute;
    top: 0;
    left: 0;
  }
  .image .actions a{
    font-size: 8px;
  }

  .image:hover .actions{
    display: block;
  }

  .input.inline .hide-inline{
    display: none;
  }

  .upload-manager label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
  }
  .upload-manager .drop-active {
		opacity:0;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    position: absolute;
    z-index: 9999;
    text-align: center;
    background: #000;
  }

	.upload-manager .drop-active.hover{
		opacity:.6;
	}

  .upload-manager .drop-active h3 {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 20px;
    color: #fff;
    padding: 0;
  }
</style>


<style>
	.hover-image{
		position:absolute;
		top:0;
		z-index: 10;
		width:400px;
		height:auto;
		border:1px solid #ccc;
	}
</style>
